import api from './api.service';

export const userService = {
    async list() {
        const resp = await api.get('/users');
        return resp.data.data;
    },

    async get(id: string) {
        const resp = await api.get(`/users/${id}`);
        return resp.data.data;
    },

    async create(data: {
        email: string; password: string; name: string; role_id?: string;
        phone?: string | null; notify_email?: boolean; notify_message?: boolean;
    }) {
        const resp = await api.post('/users', data);
        return resp.data.data;
    },

    async update(id: string, data: {
        name?: string; email?: string; role_id?: string; password?: string;
        phone?: string | null; notify_email?: boolean; notify_message?: boolean;
    }) {
        const resp = await api.patch(`/users/${id}`, data);
        return resp.data.data;
    },

    async delete(id: string) {
        const resp = await api.delete(`/users/${id}`);
        return resp.data;
    },

    async getRolesList() {
        const resp = await api.get('/users/roles-list');
        return resp.data.data;
    },

    // ─── Node access (provisions the user onto local nodes) ─────

    /** Grants + implicit-access flag for a user. */
    async getNodeAccess(userId: string) {
        const resp = await api.get(`/user-node-access/${userId}`);
        return resp.data.data as { implicit_all_nodes: boolean; grants: any[] };
    },

    /** The node's OWN role list (live when online, cached otherwise). */
    async getNodeRoles(nodeId: string) {
        const resp = await api.get(`/user-node-access/node-roles/${nodeId}`);
        return resp.data.data as { roles: Array<{ id: string; name: string; description?: string }>; cached: boolean; refreshedAt: string | null };
    },

    async grantNodeAccess(userId: string, nodeId: string) {
        // No node-role: the user is provisioned mirroring their cloud role.
        // Camera/group scope is assigned separately via setNodeScope.
        const resp = await api.post(`/user-node-access/${userId}`, { node_id: nodeId });
        return resp.data.data;
    },

    async revokeNodeAccess(userId: string, nodeId: string) {
        const resp = await api.delete(`/user-node-access/${userId}/${nodeId}`);
        return resp.data;
    },

    // ─── Per-node camera/group scope (Access Control) ───────────

    /** Cloud users granted on a node, with their current camera/group scope. */
    async getNodeUsers(nodeId: string) {
        const resp = await api.get(`/user-node-access/node/${nodeId}/users`);
        return resp.data.data as any[];
    },

    /** Replace a user's camera/group scope on a node (re-provisions the node). */
    async setNodeScope(userId: string, nodeId: string, groupIds: string[], cameraIds: string[]) {
        const resp = await api.put(`/user-node-access/${userId}/${nodeId}/scope`, {
            group_ids: groupIds,
            camera_ids: cameraIds,
        });
        return resp.data.data;
    },
};